import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './QuickMenu.scss';

class QuickMenu extends Component {
  render() {
    return (
      <div className="quick-menu">
        <div className="quick-menu__head-title">Quick Menu</div>
        <ul>
          <li>
            <img src="/image/quickmenu/usage.svg" alt="" />
            <Link to="/my-pc-bang/usage-status/payment-and-billing">사용내역</Link>
          </li>
          <li>
            <img src="/image/quickmenu/purchase.svg" alt="" />
            <Link to="/products/purchase">상품 구매하기</Link>
          </li>
          <li>
            <img src="/image/quickmenu/taxinvoice.svg" alt="" />
            <Link to="/my-pc-bang/tax-invoice">세금계산서발행</Link>
          </li>
          <li>
            <img src="/image/quickmenu/ip.svg" alt="" />
            <Link to="/my-pc-bang/management/ip-management">IP관리</Link>
          </li>
          <li>
            <img src="/image/quickmenu/transferdocument.svg" alt="" />
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://lolstatic-a.akamaihd.net/riot-kr/docs/pcbang/OwnershipTransfer.pdf"
            >
              양수도 서류 다운로드
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default QuickMenu;
